var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"ods-form",class:[
  _vm.labelPosition ? 'ods-form--label-' + _vm.labelPosition : '',
  { 'ods-form--inline': _vm.inline }
],attrs:{"data-name":"OdsForm"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }